// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-pdp-extras.liquid so the browser can cache it. Code unchanged.
(function(){
  /* ---------- Part A: business-day delivery window ---------- */
  function addBusinessDays(d, n){ var r=new Date(d); var added=0; while(added<n){ r.setDate(r.getDate()+1); var w=r.getDay(); if(w!==0&&w!==6) added++; } return r; }
  function fmt(d){ return d.toLocaleDateString('en-AU',{weekday:'short',day:'numeric',month:'short'}); }
  /* 27 Sep 2026: the computed date range is switched off (Yass prefers "2 to 7 business days"); helpers kept in case it comes back */

  /* ---------- Part B: add-on picker ---------- */
  var CLEANER_ID=37161153462438;
  var wrap=document.querySelector('[data-adore-pdp-extras]'); if(!wrap) return;
  var map={}; try{ map=JSON.parse(wrap.getAttribute('data-kit-map')||'{}'); }catch(e){}
  var box=wrap.querySelector('[data-adore-kit-wrap]');
  var product=wrap.closest('[data-js-product]')||document;
  function variantInput(){ return product.querySelector('[name="id"]'); }
  function current(){ var i=variantInput(); return i? map[String(i.value)] : null; }
  function choice(){ var r=box.querySelector('[data-adore-addon]:checked'); return r? r.value : ''; }
  function q(sel){ return box.querySelector(sel); }
  /* 27 Sep 2026 (Yass): Add to Cart sits directly under the price (and the "You save" line), and the add-on picker
     stays below the button. The button's form is moved up here, synchronously during page parse, before first paint.
     (Until 27 Sep the picker was moved ABOVE the button instead.) */
  var atcBlock=(function(){ var b=product.querySelector('.product-page-info [data-js-product-button-add-to-cart]'); return b ? b.closest('.form') : null; })();
  (function(){
    if(!atcBlock || !atcBlock.parentNode) return;
    var price=product.querySelector('.product-page-info__price');
    var sale=product.querySelector('.product-page-info__price-sale-details');
    var ap=product.querySelector('[data-adore-afterpay-line]'); /* 27 Sep 12:27: Afterpay line (adore-trust-strip) sits between You save and the button */
    var after=(ap && ap.parentNode===atcBlock.parentNode) ? ap : (sale && sale.parentNode===atcBlock.parentNode) ? sale : (price && price.parentNode===atcBlock.parentNode ? price : null);
    if(after){ atcBlock.style.marginTop='12px'; after.parentNode.insertBefore(atcBlock, after.nextSibling); }
    box.style.marginTop='4px';
  })();
  /* 27 Sep 2026 (Yass): Part C, move the theme's Size guide / Delivery & return / Message links into the help panel as pills */
  (function(){
    function movePills(){
      var pills=wrap.querySelector('[data-adore-help-pills]'); var db=product.querySelector('.product-page-info__details-buttons');
      if(!pills || !db) return;
      [].slice.call(db.querySelectorAll('.btn-link')).forEach(function(b){
        b.classList.remove('h6','mb-10','d-flex');
        /* 1 Oct 2026 17:01 (Nas): normal capitalisation. The theme writes these labels in capitals ("SIZE GUIDE"),
           so each label becomes sentence case here: "Size guide", "Delivery & return", "Message". */
        [].forEach.call(b.childNodes,function(n){ if(n.nodeType===3 && n.textContent.trim()){ var s=n.textContent.trim().toLowerCase(); n.textContent=s.charAt(0).toUpperCase()+s.slice(1); } });
        pills.appendChild(b);
      });
    }
    /* the links sit further down the page than this block, so wait for the DOM to finish */
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',movePills); else movePills();
  })();
  /* 27 Sep 2026 12:27 (Yass + panel audit): the sticky Add to Cart bar shows whenever the page's own Add to Cart is OFF
     screen, and hides while it is ON screen. So: visible on landing (the page button is below the fold on phones), gone
     while the page button is in view, back once it has been scrolled past.
     How: the theme's own footbar logic is switched off (its marker attribute is removed, so its module never binds) and an
     IntersectionObserver on the Add to Cart form toggles .adore-fb-on (+ the theme's footbar-product--visible class, which
     adore-podium-offset reads). Styling of the bar lives in adore-pdp-style (section 8). */
  (function(){
    [].forEach.call(document.querySelectorAll('[data-js-footbar-product-limit]'),function(l){ l.removeAttribute('data-js-footbar-product-limit'); });
    function start(){
      var fb=document.querySelector('.js-footbar-product'); if(!fb || !atcBlock) return;
      fb.classList.add('adore-fb');
      /* phones: "80x150cm · Change" under the bar price replaces the size dropdown; Change scrolls to the size pills */
      var priceCol=fb.querySelector('.footbar-product__price');
      /* 14 Oct 2026: footbar.liquid now renders this button on the server; it is only created here if missing, and the click is bound either way */
      var s=fb.querySelector('.adore-fb-size');
      if(priceCol && !s){
        s=document.createElement('button'); s.type='button'; s.className='adore-fb-size';
        s.innerHTML='<span data-adore-fb-size></span> <u>Change</u>';
        priceCol.parentNode.appendChild(s);
      }
      if(s && !s.__adoreBound){
        s.__adoreBound=true;
        s.addEventListener('click',function(){ var o=product.querySelector('.product-page-info__options'); if(o) window.scrollTo({top:o.getBoundingClientRect().top+window.scrollY-90,behavior:'smooth'}); });
      }
      function setOn(on){ fb.classList.toggle('adore-fb-on',on); fb.classList.toggle('footbar-product--visible',on); document.documentElement.classList.toggle('adore-fb-shown',on); }
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ setOn(!e.isIntersecting); }); },{threshold:0}).observe(atcBlock);
      } else { setOn(true); }
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
  })();
  /* keeps the "80x150cm" label in the sticky bar in step with the chosen size */
  function fbSize(){
    var el=document.querySelector('[data-adore-fb-size]'); if(!el) return;
    var sel=document.querySelector('.js-footbar-product select'); var t='';
    if(sel && sel.selectedOptions && sel.selectedOptions[0]) t=sel.selectedOptions[0].text;
    else { var a=product.querySelector('.product-page-info__options [data-js-option-value].active'); if(a) t=a.textContent; }
    var fbLabel=fmtSize((t||'').split(' / ')[0].trim());
    /* 25 Oct 2026 (panel audit, finding 5): on phones and tablets (under 1025px) the bar's size column is about 164px wide at 375px,
       so "80 x 300 cm runner" plus the Change pill did not fit and the text showed as "80 x 300 cm ru...". In the bar only, the
       words "runner" and "round" are dropped from the label on those screens, so it reads "80 x 300 cm" with the pill whole.
       The size tiles on the page and the Change list keep the full wording. Desktop keeps the full label too. */
    if(window.innerWidth<1025) fbLabel=fbLabel.replace(/\s*\b(runner|round)\b/gi,'').replace(/\s{2,}/g,' ').trim();
    el.textContent=fbLabel;
    /* 14 Oct 2026: the theme re-renders the bar price on a size change with " from" between the two prices; drop that text */
    [].forEach.call(document.querySelectorAll('.js-footbar-product .price--sale'),function(p){ [].slice.call(p.childNodes).forEach(function(n){ if(n.nodeType===3 && /\S/.test(n.nodeValue)) p.removeChild(n); }); });
    /* 23 Oct 2026 (panel 22 Oct, UI/UX 3): the bar shows the saving for the chosen size, e.g. "Save $391", the same figure as the
       page. On phones it replaces the struck-out price so the bar stays one line (CSS in adore-pdp-style). */
    [].forEach.call(document.querySelectorAll('.js-footbar-product .footbar-product__price'),function(pc){
      var ps=pc.querySelector('.price--sale'), sp=ps?ps.querySelectorAll('span'):[], save=0, tag=pc.querySelector('.adore-fb-save');
      function amt(t){ return parseFloat(String(t||'').replace(/[^0-9.]/g,''))||0; }
      if(sp.length>=2){ var was=amt(sp[0].textContent), now=amt(sp[sp.length-1].textContent); if(was>now) save=Math.round(was-now); }
      if(!save){ if(tag) tag.parentNode.removeChild(tag); pc.classList.remove('adore-fb-has-save'); return; }
      if(!tag){ tag=document.createElement('span'); tag.className='adore-fb-save'; pc.appendChild(tag); }
      var txt='Save $'+save.toLocaleString('en-AU'); if(tag.textContent!==txt) tag.textContent=txt;
      pc.classList.add('adore-fb-has-save');
    });
  }
  /* 14 Oct 2026: sizes read "240 x 340 cm" (house style), runners "80 x 300 cm runner"; anything else is shown as stored */
  function fmtSize(t){
    var m=/^(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm\s*(.*)$/i.exec(t);
    if(m) return m[1]+' x '+m[2]+' cm'+(m[3] ? ' '+m[3].toLowerCase() : '');
    var r=/^(\d+(?:\.\d+)?)\s*cm\s*(.*)$/i.exec(t);
    if(r) return r[1]+' cm'+(r[2] ? ' '+r[2].toLowerCase() : '');
    return t;
  }
  var prices={}; try{ prices=JSON.parse(wrap.getAttribute('data-prices')||'{}'); }catch(e){}
  /* 27 Sep 2026 12:27 (panel audit): when an add-on is picked, the Add to cart label shows the total, e.g. "Add to cart, $194" */
  var atcText=(function(){ var b=product.querySelector('.product-page-info [data-js-product-button-add-to-cart] .btn__text'); return b; })();
  var atcOrig=atcText ? atcText.textContent : '';
  function addonPrice(m){ var c=choice(); if(!m) return 0; if(c==='kit') return m.price; if(c==='und') return m.undPrice; if(c==='cln') return 35; return 0; }
  function atcLabel(m){
    if(!atcText) return;
    var btn=atcText.closest('button'); var cur=atcText.textContent;
    if(cur.indexOf('$')===-1) atcOrig=/^\s*add to cart\s*$/i.test(cur) ? 'Add to cart' : cur; /* the theme may rewrite it (e.g. "Sold out"); keep its latest own text, in sentence case */
    var i=variantInput(); var p=i ? prices[String(i.value)] : 0; var a=addonPrice(m);
    if(a>0 && p && !(btn && btn.disabled)){ var tot=p/100+a; atcText.textContent='Add to cart, $'+(tot%1 ? tot.toFixed(2) : tot); }
    else if(cur!==atcOrig){ atcText.textContent=atcOrig; }
  }
  function refresh(){
    fbSize();
    var m=current();
    atcLabel(m);
    if(!m){ box.style.display='none'; return; }
    box.style.display='block';
    q('[data-adore-und-size]').textContent=m.undSize; q('[data-adore-und-size2]').textContent=m.undSize;
    q('[data-adore-und-price]').textContent='$'+m.undPrice; q('[data-adore-und-price2]').textContent='$'+m.undPrice;
    q('[data-adore-kit-was]').textContent='$'+m.was; q('[data-adore-kit-price]').textContent='$'+m.price;
    q('[data-adore-kit-save]').textContent='$'+(m.was-m.price);
  }
  // The lines to add alongside the rug for the chosen option
  function extraItems(){
    var m=current(); if(!m) return [];
    var c=choice();
    if(c==='kit') return [{id:m.kit,quantity:1}];
    if(c==='und') return [{id:m.und,quantity:m.undQty}];
    if(c==='cln') return [{id:CLEANER_ID,quantity:1}];
    return [];
  }
  refresh();
  document.addEventListener('change', function(e){ if(e.target && e.target.getAttribute && e.target.getAttribute('name')==='id') setTimeout(refresh,30); }, true);
  document.addEventListener('click', function(e){ if(product.contains(e.target)){ setTimeout(refresh,80); setTimeout(refresh,400); } }, true);
  /* 26 Sep 2026: the theme sometimes sets the chosen size a moment after the tap, so also watch the variant and refresh when it changes */
  (function(){ var lastV=''; setInterval(function(){ var i=variantInput(); if(i && i.value!==lastV){ lastV=i.value; refresh(); } },300); })();

  // Hook the theme's AJAX add-to-cart: theme.Cart.addItem(item) -> addItems([item]).
  // When an add-on is chosen and the item being added is this product's variant, send all lines in one request.
  function patch(){
    if(!window.theme||!theme.Cart) return false;
    var proto=Object.getPrototypeOf(theme.Cart);
    if(proto.__adoreKitPatched) return true;
    var orig=proto.addItem;
    proto.addItem=function(item){
      try{
        var extra=extraItems();
        if(extra.length && item && String(item.id)===String(variantInput().value)){
          return this.addItems([item].concat(extra));
        }
      }catch(e){}
      return orig.call(this,item);
    };
    proto.__adoreKitPatched=true; return true;
  }
  if(!patch()){ var tries=0; var t=setInterval(function(){ if(patch()||++tries>50) clearInterval(t); },200); }

  // Non-AJAX fallback (cart_ajax off): append the add-on as extra lines via items[] fields on submit.
  var form=product.querySelector('form[data-js-product-form]');
  if(form){ form.addEventListener('submit', function(){
    var extra=extraItems(); if(!extra.length) return;
    if(window.theme&&theme.Cart&&Object.getPrototypeOf(theme.Cart).__adoreKitPatched) return;
    extra.forEach(function(x,i){
      var a=document.createElement('input'); a.type='hidden'; a.name='items['+(i+1)+'][id]'; a.value=x.id; form.appendChild(a);
      var b=document.createElement('input'); b.type='hidden'; b.name='items['+(i+1)+'][quantity]'; b.value=x.quantity; form.appendChild(b);
    });
  }); }
})();
